module.exports = __webpack_public_path__ + "static/media/ElectricalTest.891406d4.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/productionProgress/ElectricalTest.mp4
// module id = 1486
// module chunks = 0